const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/studentspace/homepage'], resolve)
}

export default homepage
